/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from "yup";

export const couponSchema = Yup.object().shape({
  name: Yup.string()
    .max(50, "Maximum 50 letters")
    .required("Name is required"),

  couponType: Yup.string()
    .required("Coupon type is required"),

  amount: Yup.string()
    .matches(
      /^[1-9]\d{0,5}$/,
      "Amount must be up to 6 digits and greater than 0"
    )
    .required("Coupon value is required"),

  limit: Yup.string()
    .matches(
      /^[1-9]\d{0,5}$/,
      "Coupon Limit must be up to 6 digits and greater than 0"
    )
    .required("Coupon Limit is required"),

  minimumOrderValue: Yup.string()
    .matches(
      /^[1-9]\d{0,5}$/,
      "Minimum Order Value must be up to 6 digits and greater than 0"
    )
    .required("Minimum Order Value is required"),

  usagePerUser: Yup.string()
    .matches(
      /^[1-9]\d*$/,
      "Usage Per User must be a number greater than 0"
    )
    .required("Usage Per User is required"),

  startDate: Yup.string()
    .required("Coupon Start Date is required"),

  endDate: Yup.string()
    .required("Coupon End Date is required"),
});
